import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import userSession from './UserSession'
import message from './messageStore'
import activeCalls from './activeCalls'
import summary from './summary'
import calls from './calls'
import geoRegions from './geoRegions'
import geoCount from './geoCount'
import callDetail from './callDetail'
import licenseOverage from './licenseOverage'
import agentIds from './agentIds'
import tenantInfo from './tenantInfo'
import packetDataT from './packetDataT'
import packetDataS from './packetDataS'
import modality from './modality'
import ladder from './ladder'

export default history => 
  combineReducers({
    router: connectRouter(history),
    userSession,
    message,
    activeCalls,
    summary,
    calls,
    geoRegions,
    geoCount,
    callDetail,
    licenseOverage,
    agentIds,
    tenantInfo,
    packetDataT,
    packetDataS,
    modality,
    ladder
  });
